import { Component ,OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FaqService } from '../../service/faq.service';
import { DatePipe } from '@angular/common';
import { CreateChatReqRes } from '../../model/chat.model';
import { CreateQuestionAnswerRequest } from '../../model/faq.model'
import { Subscription, timestamp } from 'rxjs';
import { InteractionService } from '../../service/interaction/interaction.service';
import { ActivatedRoute } from '@angular/router';
import html2pdf from 'html2pdf.js';
import { marked } from 'marked';
import { ToastrService } from 'ngx-toastr';
import { TextToSpeechService } from '../../service/text-to-speech/text-to-speech.service';
import { ChatDetails } from '../../model/interaction.model';
import { TraineeListService } from '../../service/trainee-list.service';
import { PlatformRegionService } from '../../service/shared/platform-region.service';
@Component({
    selector: 'app-cust-faq',
    templateUrl: './cust-faq.component.html',
    styleUrl: './cust-faq.component.scss',
    standalone: false
})

export class CustFaqComponent implements OnInit {
  conversation: any[] = [];
  currentTime: any;
  currentIndex: number = 0;
  totalScore: number = 0;
  userAnswer: string = '';
  loaderMessages: string = '';
  userId: number = 0;
  conversationHistory: any[] = []; // Array to store conversation history
  @ViewChild('scrollMe') private myScrollContainer!: ElementRef;
  @ViewChild('textarea') textareaRef: ElementRef<HTMLTextAreaElement>;
  @ViewChild('scrollContainer') private scrollContainer: ElementRef;
  showOverlayContent: boolean = true;
  showOverlay: boolean = true;
  isInputEnabled: boolean = false;
  currentDisplayData = [];
  topic:boolean=true;
  dataGuardeils:boolean = true;
  toggleFirstSecond = 0;
  score: boolean = false;
  averageAge: number;
  feedback: string;
  creatChatSubscription: any = new Subscription();
  dataObject: any = {
    chat_session_id: 0
  }
  givenName: string ;
  historyOn: boolean = false;
  mute: boolean = true;
  createSessionFirstTimeFlag: boolean = true;
  private previousScrollHeight: number;
  mic: boolean = false;
  textToSpeechEnabled = false;
  constructor(private apiService: FaqService, private datePipe: DatePipe, 
    private renderer: Renderer2, private intrService: InteractionService, 
    private route: ActivatedRoute, private toastr: ToastrService, 
    private tts: TextToSpeechService, private readonly traineeListService: TraineeListService,
  private platformRegionService: PlatformRegionService) { }

  ngOnInit(): void {
    this.userId = Number(sessionStorage.getItem('userId'));
    this.givenName = sessionStorage.getItem("givenName");
    this.hideLoader();
    //this.getCurrentTime();
    this.intrService.refreshHistoryHandler({refreshMenu: 'faq'});
    this.traineeListService.getCustomizeDetails().subscribe({
      next: (data: any) => {
        this.textToSpeechEnabled = data.enable_voice_interaction;
      }
    })
    /* let faqHistoryFlag = this.route.snapshot.queryParamMap.get('chat');
    this.historySessionId = Number(this.route.snapshot.queryParamMap.get('id')); */
    this.intrService.loadHistorydetailsObservable$.subscribe((value: any) => {
      this.createSessionFirstTimeFlag = false;
      if(value.chat === 'FAQ') {
        this.getFaqHistory(value.id);
      }
    });
    this.intrService.chatstatus.subscribe((value: ChatDetails) => {
      this.createSessionFirstTimeFlag = true;
      if (value.chat_identifier === 'newchat') {
        this.resetConversation(); 
        this.showOverlay = true;
        this.isInputEnabled = true;
      } else {
        this.showOverlay = false;
        this.isInputEnabled = false;
      }
    });
   // this.createChatSession();
    setTimeout(() => {
      this.scrollToBottom();
    }, 300);
  }
  resetConversation() {
    this.userAnswer ='';
    this.conversation = [];
    //this.conversationHistory=[];
    this.toggleFirstSecond = 0;
    this.createSessionFirstTimeFlag = true;
  }
  ngAfterViewChecked(): void {
    if (this.scrollContainer.nativeElement.scrollHeight !== this.previousScrollHeight) {
      this.scrollToBottom();
      this.previousScrollHeight = this.scrollContainer.nativeElement.scrollHeight;
    }
  }
  
  scrollToBottom(): void {
    const container = this.scrollContainer.nativeElement;
    container.scroll({
      top: container.scrollHeight,
      behavior: 'smooth'
    });
  }
/*   scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  } */
  focusTextarea() {
    this.textareaRef.nativeElement.focus();
  }
  adjustHeight(event: Event) {
    const textarea = this.textareaRef.nativeElement;
    const overlayContent = document.querySelector('.overlay-content') as HTMLElement;
    textarea.style.height = '35px';
    const maxHeight = 120; 
    textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`;
    if (textarea.scrollHeight > textarea.clientHeight) {
      textarea.classList.add('scrollable');
    } else {
      textarea.classList.remove('scrollable');
    }
    if (overlayContent) {
      const baseBottom = 40; 
      const textareaHeight = Math.min(textarea.scrollHeight, maxHeight);
      const buffer = 10; 
      const newBottom = baseBottom + textareaHeight + buffer;

      overlayContent.style.bottom = `${newBottom}px`;
    }
  }
  convertUtcToLocal(utcDateString: string): Date | null {
    return new Date (this.datePipe.transform(utcDateString.split('.')[0] + 'Z','yyyy-MM-dd HH:mm:ss'));
  }
  MuteAudio(){
    this.mute = !this.mute;
    if (this.mute) {
      this.tts.pauseSpeech();
    } else {
      this.tts.resumeSpeech();
    }
  }

  getFaqHistory(sessionId) {
    this.showOverlay = false;
    this.historyOn = true;
    this.apiService.chatFaqHistoryList(sessionId).subscribe((response) => {
        this.conversation = response;
        this.conversation = response.map(item => {
          return {
              ...item,
              ai_timestamp: this.convertUtcToLocal(item.request_time), // Convert to local time
              user_timestamp: this.convertUtcToLocal(item.response_time), 
              
          };
          
      })  ;    
    });
  }
  backbutton() {
    this.showOverlay = true;
    this.historyOn = false;
    this.score = false;
    this.conversation = [];
    this.conversationHistory = [];
  }
  createChatSession(chatRequest: CreateChatReqRes) {
    this.creatChatSubscription = this.apiService.createChatSession(chatRequest)
      .subscribe((res: CreateChatReqRes) => {
        this.dataObject.chat_session_id = res.chat_session_id;
        this.getNextQuestion();
      });
  }
  
  getCurrentTime(): string {
    const now = new Date();
    return this.datePipe.transform(now, 'hh:mm MMM dd') || '';
  }
  handleContent(content: string) {
    this.userAnswer = content;
    this.mute = false;
    this.mic = true;
    this.getNextQuestion()
  }
  displayTranscriptAsPdf() {
    if (this.conversation.length === 0) {
      this.toastr.info('No transcription is available to download', '', { positionClass: 'toast-top-right' });
      return;
    }
    let transcriptHtml = '';
    if (this.loaderMessages) {
      transcriptHtml += `<div style="margin-bottom: 10px;">Topic:- ${this.loaderMessages}</div>`;
    }
    transcriptHtml += this.conversation.map(chat => {
      return `
        <div style="margin-bottom: 10px;">
          <div style="display: block;">AI - ${chat.bot_question}</div>
          <div style="display: block; margin-bottom: 5px;">User - ${chat.user_answer}</div>
        </div>
      `;
    }).join('');
    const htmlContent = `
      <div>
        <h1>Transcript</h1>
        ${transcriptHtml}
      </div>
    `;
    const options = {
      margin: 0.5,
      filename: `chat_transcript_${this.dataObject.chat_session_id}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().from(htmlContent).set(options).save(); // Directly save the PDF file
  }
  
  getNextQuestion() {
    if (this.userAnswer?.trim() === '') {
        return;
    }
    const textarea = this.textareaRef.nativeElement;
    textarea.style.height = '35px';

    if (this.createSessionFirstTimeFlag) {
      this.createSessionFirstTimeFlag = false; // Set the flag to false after the first session is created

      let chatRequest: CreateChatReqRes = {
          chat_topic: "NA",
          chat_name: "faq",
          chat_user_id: this.userId,
          chat_end_time: this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          chat_start_time: this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          chat_type: "faq",
          business_unit_code: this.platformRegionService.selected_platform_code,
        region_name: this.platformRegionService.selected_region_code,
        primary_market: this.platformRegionService.selected_market_code,
        product: this.platformRegionService.selected_platform_code,
      };

      this.createChatSession(chatRequest);
  } else {
        const chatBox = document.getElementById('chat-box');
        chatBox.scrollTop = chatBox.scrollHeight; // Auto-scroll to the bottom

        this.showOverlay = false;
        this.toggleFirstSecond++;
        let questionRequest: CreateQuestionAnswerRequest = {
            chat_session_id: this.dataObject.chat_session_id,
            user_request: this.userAnswer,
        }

        this.loaderMessages = this.userAnswer;
        const loaderMessage = document.getElementById('loader-message');
        loaderMessage.textContent = `Loading FAQs for the topic "${this.loaderMessages}". Please wait...`;

        if (this.toggleFirstSecond == 1) {
            this.showLoader();
            this.historyOn = true;
            this.userAnswer = '';

            this.apiService.getQuestionAnswer(questionRequest).subscribe((data: any) => {
                if (data.guardrail_trigger) {
                    this.toastr.error(data.message);
                    this.hideLoader();
                    this.dataGuardeils = false;
                    this.historyOn = false;
                    this.toggleFirstSecond--;
                    return; 
                } else {
                    data = data.content;
                    data.map(data => {
                        data.user_answer = "";
                        data.bot_idle_answer = data.bot_idle_answer;
                    });
                    this.currentDisplayData = data;
                    this.showOverlayContent = true;
                    const currentDisplayDataNew = this.currentDisplayData.slice(0, this.toggleFirstSecond);
                    if (!this.mute && this.textToSpeechEnabled) {
                        this.tts.speak(currentDisplayDataNew[0].bot_question);
                        if(this.mic){
                          this.mute = true;
                        }
                    }
                    if (currentDisplayDataNew.length > 0) {
                        currentDisplayDataNew[0]['ai_timestamp'] = this.getCurrentTime();
                    }
                    this.hideLoader();
                    this.historyOn = false;
                    this.conversation = currentDisplayDataNew;
                    this.intrService.refreshHistoryHandler({ refreshMenu: 'faq' });
                }
            });
        } else {
            const currentDisplayDataNew = this.currentDisplayData.slice(0, this.toggleFirstSecond);
            currentDisplayDataNew[this.toggleFirstSecond - 2].user_answer = this.userAnswer;
            currentDisplayDataNew[this.toggleFirstSecond - 2]['user_timestamp'] = this.getCurrentTime();
            const getAnswerScoreReq = {
                chat_session_id: this.dataObject.chat_session_id,
                qna_id: currentDisplayDataNew[this.toggleFirstSecond - 2].id,
                user_request: this.userAnswer,
                request_time: new Date()
            }
            this.showSmallLoader();
            this.historyOn = true;

            this.apiService.getAnswerScore(getAnswerScoreReq).subscribe((data: any) => {
                this.totalScore += data.bot_score;
                currentDisplayDataNew[this.toggleFirstSecond - 2].bot_score = data.bot_score;

                if (this.toggleFirstSecond == 11) {
                    this.historyOn = true;
                    this.score = true;
                    this.hideSmallLoader();
                    this.feedback = "Thank you for successfully finishing your knowledge assessment.";
                    if (!this.mute && this.textToSpeechEnabled) {
                        this.tts.speak(this.feedback);
                        if(this.mic){
                          this.mute = true;
                        }
                    }
                    return;
                }
                this.hideSmallLoader();
                this.historyOn = false;

                if (currentDisplayDataNew[this.toggleFirstSecond - 1]) {
                    currentDisplayDataNew[this.toggleFirstSecond - 1]['ai_timestamp'] = this.getCurrentTime();
                    if (!this.mute && this.textToSpeechEnabled) {
                        this.tts.speak(currentDisplayDataNew[this.toggleFirstSecond - 1].bot_question);
                        if(this.mic){
                          this.mute = true;
                        }
                    }
                }

                this.conversation = currentDisplayDataNew;
            });
            this.userAnswer = '';
        }

        if (this.userAnswer.trim() !== '') {
            if (this.topic) {
                this.topic = false;
            } else {
                // Only save history if no guardrail trigger occurred
                this.conversationHistory.push({
                    bot_question: this.conversation[this.currentIndex].bot_question,
                    answer: this.userAnswer,
                    ai_timestamp: this.getCurrentTime(),
                    user_timestamp: this.getCurrentTime()
                });
            }
            this.userAnswer = ''; // Clear the user answer
        }
        this.currentIndex++;
        this.focusTextarea();
    }
}

  showLoader() {
    const loader = document.getElementById('loader');
    loader.style.display = 'inline-block';
  }

  showSmallLoader() {
    const loader = document.getElementById('small-loader');
    loader.style.display = 'inline-block';
  }
  
  hideLoader() {
    const loader = document.getElementById('loader');
    loader.style.display = 'none';
  }

  hideSmallLoader() {
    const loader = document.getElementById('small-loader');
    loader.style.display = 'none';
  }

  getPreviousQuestion() {
    this.currentIndex--;
  }
  hideOverlay() {
    this.showOverlay = false; // Hide the overlay
  }
}